import { gql } from 'graphql-request';

export const GetReview = gql`
  query GetReview($id:ID!) {
    review(id:$id) {
      id
      userId
      trailId
      body
      rating
      createdAt
      updatedAt
      ranking
      photos {
        lgUrl
        smUrl
        mdUrl
        metadata
        id
        recordType
        recordId
        processed
      }
      likes {
        id
        userId
        likeableId
        likeableType
      }
      user {
        firebaseUserId
        avatar {
          id
          lgUrl
          smUrl
          mdUrl
          metadata
        }
        title
        displayName
      }
    }
  }
`;

export const DestroyReview = gql`
  mutation DestroyReview($review:DestroyReviewInput!) {
    destroyReview(input:$review) {
      id
      destroyed
    }
  }
`;

export const UpdateReview = gql`
  mutation UpdateReview($review:UpdateReviewInput!) {
    updateReview(input:$review) {
      id
      userId
      trailId
      body
      rating
      createdAt
      updatedAt
      ranking
      photos {
        lgUrl
        smUrl
        mdUrl
        metadata
        id
        recordType
        recordId
        processed
      }
      likes {
        id
        userId
        likeableId
        likeableType
      }
      user {
        firebaseUserId
        avatar {
          id
          lgUrl
          smUrl
          mdUrl
          metadata
        }
        title
        displayName
      }
    }
  }
`;

export const CreateReview = gql`
  mutation CreateReview($review:CreateReviewInput!) {
    createReview(input:$review) {
      id
      userId
      trailId
      body
      rating
      createdAt
      updatedAt
      ranking
      photos {
        lgUrl
        smUrl
        mdUrl
        metadata
        id
        recordType
        recordId
        processed
      }
      likes {
        id
        userId
        likeableId
        likeableType
      }
      user {
        firebaseUserId
        avatar {
          id
          lgUrl
          smUrl
          mdUrl
          metadata
        }
        title
        displayName
      }
    }
  }
`;
